module.exports = __webpack_public_path__ + "static/media/30OIOS9.f0ac4b00.jpg";